
import { defineComponent } from 'vue'

import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    setup() {
        const account = useAccount()
        return { account }
    }
})
